import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "dialog-generic",
  templateUrl: "dialog-generic.html",
  styleUrls: ["dialog-generic.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe, MatDialogClose],
})
export class DialogGenericComponent {
  private dialogRef = inject(MatDialogRef<DialogGenericComponent>);
  private data = inject(MAT_DIALOG_DATA);

  protected title = computed<string>(() => this.data.title);
  protected message = computed<string>(() => this.data.message);
  private state = computed<"success" | "error">(() => this.data.state);
  protected isSuccess = computed(() => this.state() == "success");
  protected isError = computed(() => this.state() == "error");
  protected code = computed(() => this.data.code);

  closeDialog(): void {
    this.dialogRef.close();
  }
}
